import React from 'react'
import TopSec from '../../Component/Assets/Topsec'
import Benefit from '../../Component/Assets/Benefit'
import Unlock from '../../Component/Assets/Unlock'
import Seo from '../../Component/Seo'

function AssetManangement() {
  return (
    <div>
      <Seo
        title='Halal Asset Financing Without Interest | Halal Wealth'
        description='Own the assets you need with ethical, Shariah-compliant asset financing. No riba, clear terms, and flexible repayment through Halal Wealth.'
        pathname='/assetsfinancing'
      />
      <TopSec/>
      <Benefit/>
      <Unlock/>
    </div>
  )
}

export default AssetManangement
